if (! window.bg) {
  window.bg = {}
}
var windowBg = window.bg;

export {windowBg}

